import * as angular from 'angular';
import FlowsImInGroupsBridge from './bridges/FlowsImInGroupsBridge';

// TODO when updating ImIn page to react, delete these components and use
// FlowGroups component instead
angular
  .module('flowingly.runner.flows.imin')
  .component('flowsImInGroupsV2', FlowsImInGroupsBridge);
